export default {"src":"__ASTRO_ASSET_IMAGE__CnXqrUrZ__","width":65,"height":65,"format":"webp"}